import AddNotificationRuleForm from './AddNotificationRuleForm';

export default AddNotificationRuleForm;
